"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IrrigationPoolPumpSolutions() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="3384" id="irrigationpoolpumpsolutions" className="bg-background py-24 md:py-32 lg:py-40 border-b border-border/50">
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <div ref={headerRef} className={`transition-all duration-1000 ease-out ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
          <div className="mb-8 flex items-center gap-4">
            <span className="block h-px w-10 bg-primary" aria-hidden="true" />
            <span className="font-default text-sm uppercase tracking-[0.2em] font-bold text-primary">
              Our Solutions
            </span>
          </div>

          <h2 className="font-default font-bold text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-foreground mb-12">
            Our Irrigation and <br className="hidden md:block" />
            <span className="text-primary">Pool Pump Solutions</span>
          </h2>

          <div className="pl-6 border-l-4 border-accent space-y-6">
            <p className="font-sans text-xl md:text-2xl font-light text-muted-foreground leading-relaxed">
              AA Eagle Plumbing handles pool pump replacement, pool pump installation, well pump service, and full irrigation system repair for residential and commercial properties throughout several the Miami metro area.
            </p>
            <p className="font-sans text-xl md:text-2xl font-light text-muted-foreground leading-relaxed">
              We diagnose the issue, quote the fix, and get the system back up. It’s just up to you to call us and we’ll be there.
            </p>
          </div>
        </div>
      </div>
    </section>;
}